<template>
	<div class="text-center d-block" :class="{ 'mt-3' : with_margin_top}">
    <img src="../../assets/img/icon/loading.gif" width="80">
  </div>
</template>
<script type="text/javascript">
	export default{
		props:{
			with_margin_top:{
				type: Boolean,
				default: true
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/Loader.vue